module.exports = __webpack_public_path__ + "static/img/icon-takeout.d9798a7c.png";